<!-- 首页 -->
<template>
  <div class="container flex flex-column height-all">
    <!-- 顶部搜索模块 -->
    <div class="searchContainer flex-shrink">
      <baseSearch :searchData="searchData" :isShowExport="isShowExport" @searchClick="searchBtnClick" @exportClick="exportBtnClick"/>
    </div>
    <!-- 主体表格 -->
    <div class="mainTable height-all">
      <basetable tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="productList" :showopera="true" :currentPage="searchDataParam.pageNo" operaWidth="120"
                 :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true"
                 :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                 @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
        <template v-slot:linkCount="scope">
          <div class="progressBox" v-if="scope.scope.row.percentage != -1">
            <el-progress type="circle" :percentage="scope.scope.row.percentage" :width="20" :stroke-width="3" :show-text="false" color="#4A7FF8"></el-progress>
            <span>{{scope.scope.row.linkCountText}}</span>
          </div>
        </template>
        <template v-slot:opera="scope">
          <el-button  plain type="primary" size="small" class="tableOptionBtn" @click="checkOrderDetails(scope.scope,$event)">查看详情</el-button>
        </template>
      </basetable>
    </div>

    <!-- 查看详情遮罩层 -->
    <basedialog title="订单详情" :dialogVisible="isShowOrderDetails" dialogWidth="1250" dialogHeight="600" footerBtnType="close" closeText="关闭" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose">
      <template #dialogbody>
        <div class="addMemberShipCoverDiv flex flex-column height-all">
          <div class="orderDetailsInfo">
            <el-divider content-position="center">订单信息</el-divider>
            <div class="orderDetailsInfoDiv">
              <div class="orderDetailsInfoItem">
                <span>订单号：</span>
                <p v-text="orderDetailsInfo.orderNo"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>生产编号：</span>
                <p v-text="orderDetailsInfo.productNum || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>产品名称：</span>
                <p v-text="orderDetailsInfo.proName || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>产品数量：</span>
                <p v-text="orderDetailsInfo.worksCount || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>订单说明：</span>
                <p v-text="orderDetailsInfo.checkDescs || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>生产说明：</span>
                <p v-text="orderDetailsInfo.productDesc || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>用户留言：</span>
                <p v-text="orderDetailsInfo.userRemark || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>支付时间：</span>
                <p v-text="orderDetailsInfo.payTailTime || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>审核时间：</span>
                <p v-text="orderDetailsInfo.checkTime || '--'"></p>
              </div>
              <div class="orderDetailsInfoItem">
                <span>发货时间：</span>
                <p v-text="orderDetailsInfo.sendTime || '--'"></p>
              </div>
            </div>
          </div>

          <!-- 主体表格 -->
          <el-divider content-position="center">快递信息</el-divider>
          <div class="mainTabledialog height-all">
            <basetable tableBoxClass="mainTabledialog" :tableTitle="expressTableTitle" :tableData="orderDetailsInfo.expressList" :tableHeightData="300">
            </basetable>
          </div>
        </div>
      </template>
    </basedialog>

  </div>
  <!-- 订单详情遮罩层 -->
  <div class="orderDetailsCover width-all height-all position-fixed top-0 left-0 zIndex-top flex align-center justify-center" v-if="isShowOrderDetailsCover">
    <div class="orderDetailsDiv position-relative">
      <h3 class="coverTitle">订单详情</h3>
      <div class="closeCoverDiv position-absolute flex align-center justify-center" @click="isShowOrderDetailsCover = false">
        <img src="../../static/images/icon_close.png" alt="">
      </div>

      <div class="orderDetailsInfo">
        <el-divider content-position="center">订单信息</el-divider>
        <div class="orderDetailsInfoItem">
          <span>订单号：</span>
          <p v-text="orderDetailsInfo.orderNo"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>生产编号：</span>
          <p v-text="orderDetailsInfo.productNum || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>产品名称：</span>
          <p v-text="orderDetailsInfo.proName || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>产品数量：</span>
          <p v-text="orderDetailsInfo.proName || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>订单说明：</span>
          <p v-text="orderDetailsInfo.checkDescs || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>生产说明：</span>
          <p v-text="orderDetailsInfo.productDesc || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>用户留言：</span>
          <p v-text="orderDetailsInfo.userRemark || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>支付时间：</span>
          <p v-text="orderDetailsInfo.payTailTime || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>审核时间：</span>
          <p v-text="orderDetailsInfo.checkTime || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>发货时间：</span>
          <p v-text="orderDetailsInfo.sendTime || '--'"></p>
        </div>
        <el-divider content-position="center">收货人信息</el-divider>
        <div class="orderDetailsInfoItem">
          <span>收货人姓名：</span>
          <p v-text="orderDetailsInfo.addressRealName || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>收货人电话：</span>
          <p v-text="orderDetailsInfo.addressPhone || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>收货人地址：</span>
          <p v-text="orderDetailsInfo.addressDetail || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>快递公司：</span>
          <p v-text="orderDetailsInfo.expressName || '--'"></p>
        </div>
        <div class="orderDetailsInfoItem">
          <span>快递单号：</span>
          <p v-text="orderDetailsInfo.expressNum || '--'"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
  inject: ['$http', '$api', '$utils','$userUtils'],
  name: "groupOrderList",
  components: {
    baseSearch,
    basetable,
    basedialog,
    tableDataSelect,
  },
  data() {
    return{
      searchData: [
        {
          label: "订单号",
          type: "input",
          name: "orderNo",
          value: ""
        }, {
          label: "生产编码",
          type: "input",
          name: "productNum",
          value: ""
        },{
          label: "生产批次",
          type: "input",
          name: "productBatch",
          value: ""
        },{
          label: "生产账号",
          type: "select",
          name: "productUserId",
          options: [],
        },{
          label: "产品名称",
          type: "input",
          name: "productName",
          value: ""
        },{
          label: "收货人电话",
          type: "input",
          name: "recieverPhone",
          value: ""
        },{
          label: "快递方式",
          type: "select",
          name: "expressCompany",
          options: [],
        }, {
          label: "会员号",
          type: "input",
          name: "memberNo",
          value: ""
        },{
          label: "团单状态",
          type: "select",
          name: "orderStatus",
          options: [],
        }, {
          label: "发货时间",
          type: "datetimerange",
          name: "productionTime",
          value: [],
        }
      ],
      isLoading: false,
      tableTitle: [
        {
          label: '订单号',
          prop: 'orderNo',
		  width:200
        }, {
          label: '生产编码',
          prop: 'productNum',
              width: 250
        }, {
          label: '生产批次',
          prop: 'productBatch',
		  width:140
        }, {
          label: '产品名称',
          prop: 'proName',
          width: 250
        }, {
          label: '生产数量',
          prop: 'worksCount',
          width: 80
        }, {
          label: '生产账号',
          prop: 'productUserName',
          width: 250
        }, {
          label: '订单状态',
          prop: 'statusStr',
          width: 120
        }, {
          label: '订单说明',
          prop: 'checkDescs',
        }, {
          label: '支付时间',
          prop: 'payTailTime',
          width: 180
        }, {
          label: '生产时间',
          prop: 'productTime',
		  width: 180
        }, {
          label: '发货时间',
          prop: 'sendTime',
		  width: 180
        }
      ],
      expressTableTitle: [
        {
          label: '收货人姓名',
          prop: 'realName',
        }, {
          label: '收货人电话',
          prop: 'phone',
        }, {
          label: '收货人地址',
          prop: 'detail',
        }, {
          label: '快递公司',
          prop: 'expressCompany',
        }, {
          label: '快递单号',
          prop: 'expressNum',
        }, {
          label: '备注',
          prop: 'remark',
        }
      ],
      productList: [],
      orderIds: [],
      total: 0,
      searchDataParam:{
        pageNo:1,
        pageSize:20,
      },
      isShowOrderDetailsCover: false,  //是否显示订单详情遮罩层
      orderDetailsInfo: {},  //订单详情
      isShowExport:true,
      isShowOrderDetails: false,
    }
  },
  mounted() {
    //获取生产商账号筛选项
    this.getProductUserOptions();

    //获取快递方式筛选项
    this.getSupportExpressOptions();

    //公共字典
    this.getCommonDicts("团单状态");

    //获取订单列表
    // this.getOrderList();
  },

  methods:{
    /**
     * 获取生产商账号筛选项
     */
    getProductUserOptions() {
      let that = this;
      that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
        if(res.code == 200) {
          that.searchData[3].options = [];
          res.data.forEach((item)=>{
            that.searchData[3].options.push({'label':item.name,'value':item.code})
          })
        }
      })
    },
    /**
     * 获取快递方式筛选项
     */
    getSupportExpressOptions() {
      let that = this;
      that.$http.post(that.$api.getSupportExpressOptionsApi).then(res => {
        if(res.code == 200) {
          that.searchData[6].options = [];
          res.data.forEach((item)=>{
            that.searchData[6].options.push({'label':item.name,'value':item.code})
          })
        }
      })
    },
    /**
     * 根据类型获取字典数据
     * @param {Object} dictType
     */
    getCommonDicts(dictType) {
      let that = this;
      that.$http.post(that.$api.getCommonDictsApi, {
        "type": dictType,
      }).then(res => {
        if(res.code == 200) {
          if(dictType == "团单状态") {
            that.searchData[8].options = [];
            res.data.forEach((item)=>{
              that.searchData[8].options.push({'label':item.name,'value':item.code})
            })
          }
        }
      })
    },
    /**
     * 初始化获取订单列表
     */
    getOrderList() {
      let that = this;
      that.isLoading = true;
      that.$http.post(that.$api.getGroupOrderListApi, {
        "pageNo": that.searchDataParam.pageNo,
        "pageSize": that.searchDataParam.pageSize,
        "orderNo": that.searchDataParam.orderNo,
        "orderIds": "",  //订单ID集合
        "express": "",
        "productNum": that.searchDataParam.productNum,
        "productBatch": that.searchDataParam.productBatch,
        "productUserId": that.searchDataParam.productUserId,
        "proName": that.searchDataParam.productName,
        "phone": that.searchDataParam.recieverPhone,
        "expressType.0":  that.searchDataParam.expressCompany,
        "memberNum": that.searchDataParam.memberNo,
        "status": that.searchDataParam.orderStatus,
        "productSendStartTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[0] :'',
        "productSendEndTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[1] :''
      }).then(res => {
        that.isLoading = false;
        if(res.code == 200) {
          if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
          that.productList = res.data.list;
          //
          // //遍历数据，重置数据格式
          if(that.productList.length > 0) {
            that.productList.forEach((item, index) => {
              item.payTailTime = that.$utils.isEmpty(item.payTailTime) ? "--" : that.$utils.getDateTime(item.payTailTime);
              item.productTime = that.$utils.isEmpty(item.productTime) ? "--" : that.$utils.getDateTime(item.productTime);
              item.sendTime = that.$utils.isEmpty(item.sendTime) ? "--" : that.$utils.getDateTime(item.sendTime);
            })
          }
        }
      })
    },
    /**
     * 搜索按钮
     */
    searchBtnClick(option){
      this.searchDataParam = Object.assign(this.searchDataParam,option);
      if(!this.$utils.isEmpty(this.searchDataParam.orderNo) || !this.$utils.isEmpty(this.searchDataParam.productNum) || !this.$utils.isEmpty(this.searchDataParam.productBatch) || !this.$utils.isEmpty(this.searchDataParam.productUserId) || !this.$utils.isEmpty(this.searchDataParam.productName)
          || !this.$utils.isEmpty(this.searchDataParam.recieverPhone) || !this.$utils.isEmpty(this.searchDataParam.expressCompany) || !this.$utils.isEmpty(this.searchDataParam.memberNo) || !this.$utils.isEmpty(this.searchDataParam.orderStatus) || !this.$utils.isEmpty(this.searchDataParam.productionTime)){
            this.searchDataParam.pageNo = 1;
            this.getOrderList()
      }else{
            this.$message.warning('请输入查询条件')
      }
    },
    /**
     * 设置页码
     */
    currentChange(val){
      this.searchDataParam.pageNo = val;
      this.getOrderList()
    },
    /**
     * 设置页码
     */
    sizeChange(val){
      this.searchDataParam.pageSize = val;
      this.getOrderList()
    },
    /**
     * 查看详情按钮点击事件
     * @param {Object} scope
     */
    checkOrderDetails(scope,evt) {
      let target = evt.target;
      if(target.nodeName == "SPAN"){
        target = evt.target.parentNode;
      }
      target.blur();

      let that = this;
      that.$loading();
      that.$http.post(that.$api.getGroupOrderDetailApi, {
        "groupOrderId": scope.row.id,
        "userId": scope.row.osUserId
      }).then(res => {
        that.$loading().close();
        if(res.code == 200) {
          that.orderDetailsInfo = res.data;

          that.orderDetailsInfo.payTailTime = that.$utils.isEmpty(that.orderDetailsInfo.payTailTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.payTailTime);
          that.orderDetailsInfo.checkTime = that.$utils.isEmpty(that.orderDetailsInfo.checkTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.checkTime);
          that.orderDetailsInfo.sendTime = that.$utils.isEmpty(that.orderDetailsInfo.sendTime) ? "--" : that.$utils.getDateTime(that.orderDetailsInfo.sendTime);

          that.isShowOrderDetails = true;
        }
      }).catch(err => {
        that.$loading().close();
      })
    },
    /**
     * 关闭订单详情
     */
    dialogClose(){
      this.isShowOrderDetails = false;
    },
    /**
     * 导出
     */
    exportBtnClick(){
      let that = this;
      this.$confirm('是否只导出当前页？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '导出全部',
          distinguishCancelAndClose: true,
        type: 'warning',
        center:true
      }).then(() => {
        console.log('导出当前页')
        that.exportSimplePageData();
      }).catch((action) => {
          if (action === 'cancel') {
              console.log('导出全部')
              that.exportAllData();
          }
      });
    },
    /**
     * 导出当前页
     */
    exportSimplePageData() {
      let that = this;

      //遍历数据，获取当前要导出的订单ID
      that.orderIds = [];
      if(that.productList.length > 0) {
        that.productList.forEach((item, index) => {
          that.orderIds.push(item.id)
        })
      }

      //导出
      that.exportDyOrder(1);
    },
    /**
     * 导出全部
     */
    exportAllData() {
      let that = this;
      that.orderIds = [];
      that.exportDyOrder(0);
    },
    /**
     * 导出数据
     * @param {Object} type  1：导出当前页     0：导出全部
     */
    exportDyOrder(type) {
      let that = this;
      that.$loading();
      that.$http.post(that.$api.exportGroupOrderListApi, {
        "pageNo": that.searchDataParam.pageNo,
        "pageSize": that.searchDataParam.pageSize,
        "orderNo": that.searchDataParam.orderNo,
        "orderIds": "",  //订单ID集合
        "express": "",
        "productNum": that.searchDataParam.productNum,
        "productBatch": that.searchDataParam.productBatch,
        "productUserId": that.searchDataParam.productUserId,
        "proName": that.searchDataParam.productName,
        "phone": that.searchDataParam.recieverPhone,
        "expressType.0":  that.searchDataParam.expressCompany,
        "memberNum": that.searchDataParam.memberNo,
        "status": that.searchDataParam.orderStatus,
        "productSendStartTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[0] :'',
        "productSendEndTime": !that.$utils.isEmpty(that.searchDataParam.productionTime) ? that.searchDataParam.productionTime[1] :'',
        "expFlag": type,
      }).then(res => {
        that.$loading().close();
        if(res.code == 200) {
          that.$message.success("导出成功，请到我的文件查看");
        }
      })
    },

  },
}
</script>

<style scoped>
.mainCont .container{
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
}
/* 订单详情遮罩层 */
.orderDetailsDiv{
  width: 1200px !important;
}
.orderDetailsInfo{
  overflow: auto;
  font-size: 13px;
  margin: 0 20px 30px;
  max-height: 750px;
  overflow-y: scroll;
}
.orderDetailsInfoDiv{
  overflow: auto;
  /*margin-bottom: 40px;*/
}
.orderDetailsInfoItem{
  width: 50%;
  margin-top: 12px;
  overflow: auto;
  float: left;
}
.orderDetailsInfoItem span{
  width: 90px;
  display: inline-block;
  float: left;
  color: #666;
  line-height: 22px;
}
.orderDetailsInfoItem p{
  width: calc(100% - 90px);
  font-size: 13px;
  float: left;
  word-break: break-all;
  line-height: 22px;
}


/* 导出遮罩层 */
.exportDataCover, .orderDetailsCover{
  background-color: rgba(0, 0, 0, .5);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.exportDataDiv, .orderDetailsDiv{
  width: 400px;
  padding: 10px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  animation: fadeInDown 0.5s;
}
.coverTitle{
  text-align: center;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}
.closeCoverDiv{
  width: 30px;
  height: 30px;
  top: 15px;
  right: 15px;
  cursor: pointer;
}
.closeCoverDiv img{
  width: 20px;
}
.coverDesc{
  padding: 0 15px;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  margin: 30px 0 40px;
}
.coverOptionBtn{
  margin-bottom: 20px;
}
.coverOptionBtn button{
  width: 90px;
  height: 35px;
  padding: 0 !important;
  text-align: center;
}
.coverOptionBtn button.cancelBtn{
  background: none !important;
  color: #009688 !important;
}

.addMemberShipCoverDiv{
  display: flex;
  flex-direction: column;
  height: 600px;
}
.mainTabledialog{
  height: 300px;
}
</style>